import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchCampaigns, selectCampaigns } from "./campaignSlice";
import InsightsTable from "./InsightsTable";

function ViewData() {
  const dispatch = useDispatch();
  const campaigns = useSelector(selectCampaigns);
  const [selectedCampaignId, setSelectedCampaignId] = useState("");

  useEffect(() => {
    dispatch(fetchCampaigns());
  }, [dispatch]);

  useEffect(() => {
    if (campaigns.length > 0 && !selectedCampaignId) {
      setSelectedCampaignId(campaigns[0].id); 
    }
  }, [campaigns, selectedCampaignId]);

  const handleCampaignChange = (event) => {
    const newSelectedCampaignId = event.target.value;
    setSelectedCampaignId(newSelectedCampaignId);
  };

  const selectedCampaign = campaigns.find(campaign => campaign.id === selectedCampaignId);
  const selectedSubdomain = selectedCampaign ? selectedCampaign.subDomain : "";

  return (
    <>
      <section className="header">
        <h1>Campaign Insights</h1>

        <div className="dropdown-view-data">
          <label htmlFor="campaign-select">Select Campaign:</label>
          <select id="campaign-select" onChange={handleCampaignChange} value={selectedCampaignId}>
            <option value="" disabled>Select Campaign</option>
            {campaigns.length > 0 ? (
              campaigns.map((campaign) => (
                <option key={campaign.id} value={campaign.id}>
                  {campaign.name}
                </option>
              ))
            ) : (
              <option>No campaigns available</option>
            )}
          </select>
        </div>
      </section>
      <InsightsTable subdomain={selectedSubdomain} />
    </>
  );
}

export default ViewData;
